module.exports = __webpack_public_path__ + "static/assets/1662a0d1dd4f3e498bce1849706b4781.svg";